import React, { Component, useState, useEffect, useRef, useCallback } from "react";
import { useSize } from "react-hook-size";
import Spot from "../../common/spot/spot";
import "./listRecommendation.scss";
import * as turf from '@turf/turf'
import { Card, Accordion, Button, Container, Row, Col, ListGroup, Dropdown, Modal, Navbar, Nav, Form } from "react-bootstrap"
import parisPic from "../../images/paris.PNG"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp, faEllipsisH, faChevronLeft, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { NavLink, Redirect, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Api from "../../common/api";
import ApiV2 from "../../common/apiV2";
import Map, { Marker, GeolocateControl, ScaleControl, NavigationControl } from 'react-map-gl';
import mapboxgl, { PositionOptions } from 'mapbox-gl';
import { maxBy, minBy } from "lodash";
import PhotoUpload from "../../common/photoUpload";
import WebMercatorViewport, { Bounds } from "viewport-mercator-project"

const _ = require("lodash");
const MAPBOX_TOKEN = 'pk.eyJ1IjoiY29uZ2RvZSIsImEiOiJja205NmhqY2UxZXpuMnVwbTV0dDFvZjh4In0.aadaTJC6ZbASBxqpX8Il3A';
const geolocateControlStyle = { right: 10, bottom: 135 };
const scaleControlStyle = { left: 10, bottom: 40 };
const navControlStyle = { right: 10, bottom: 40 };

const getMinOrMax = (markers, minOrMax: "max" | "min", latOrLng: "latitude" | "longitude") => {
    if (markers !== null) {
        if (minOrMax === "max") {
            return (maxBy(markers, value => value[latOrLng]))[latOrLng];
        } else {
            return (minBy(markers, value => value[latOrLng]))[latOrLng];
        }
    }
};

const getBounds = (markers) => {
    const maxLat = getMinOrMax(markers, "max", "latitude");
    const minLat = getMinOrMax(markers, "min", "latitude");
    const maxLng = getMinOrMax(markers, "max", "longitude");
    const minLng = getMinOrMax(markers, "min", "longitude");

    const southWest = [minLng, minLat];
    const northEast = [maxLng, maxLat];

    return [southWest, northEast];
};

function ListRecommendation(props) {
    const [toggleDownState, setToggleDownState] = useState(true);
    const [currentRecList, setCurrentRecList] = useState({});
    const [currentLocation, setCurrentLocation] = useState({ latitude: null, longitude: null });
    const [flag, setFlag] = useState(false)
    const [isOpen, setIsOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedRec, setSelectedRec] = useState(null);
    const [inProfile, setInProfile] = useState(false);
    const [viewport, setViewport] = useState({
        width: 400,
        height: 400
      });
    const [firstLoad, setFirstLoad] = useState(false);
    const [markers, setMarkers] = useState(null);
    const [markerBounds, setMarkerBounds] = useState(null);
    const [mapStyle, setMapStyle] = useState("mapbox://styles/congdoe/ckmxmhljb0z7918mrmvrro060");
    const [spotName, setSpotName] = useState(null);
    const [spotCaption, setSpotCaption] = useState(null);
    const [spotIsPublic, setSpotIsPublic] = useState(null);
    const mapRef = useRef();
    const mapContainerRef = useRef(null);
    const { width, height } = useSize(mapContainerRef);

    useEffect(() => {
        const currTime = (new Date()).getHours();
        console.log("TIME: ", currTime)
        if (!(currTime > 6 && currTime < 18)) {
            setMapStyle("mapbox://styles/congdoe/ckmxn4ko50zv917pduviuis4w");
        }

        if(props.match.path.includes("/profile/")){
            setInProfile(true);
        }
    },[]);
    
    useEffect(() => {
        setCurrentRecList(props.currentRecList);
        if (Array.isArray(props.currentRecList.list)) {
            var spotMarkers = [];
            for (var i = 0; i < props.currentRecList.list.length; i++) {
                spotMarkers.push({
                    id: i,
                    longitude: props.currentRecList.list[i].mapboxData.center[0],
                    latitude: props.currentRecList.list[i].mapboxData.center[1],
                })
            }
            setMarkers(spotMarkers);
        }

        setFirstLoad(true);
    }, []);

    useEffect(() => {
        const getUpdatedRecs = async () => {
            var { data } = await ApiV2.getUserRecommendations();
            var places = [];
            if (currentRecList.name === "My Places") {
                places = data
            } else {
                places = _.filter(data, place => {
                    return place.country === currentRecList.name;
                });
            }

            var temp = { name: currentRecList.name, list: places }

            setCurrentRecList(temp);
            setFlag(false);

            //Update parent props
            props.setCurrentRecList(currentRecList.name, places);

            if (Array.isArray(places)) {
                var spotMarkers = [];
                for (var i = 0; i < places.length; i++) {
                    spotMarkers.push({
                        id: i,
                        longitude: places[i].mapboxData.center[0],
                        latitude: places[i].mapboxData.center[1],
                    })
                }
                setMarkers(spotMarkers);
            }

        }

        if (firstLoad) {
            getUpdatedRecs();
        }
    }, [flag]);

    useEffect(() => {
        const updateMarkerBounds = (newMarkers) => {
            const newBounds = getBounds(newMarkers);
            setMarkerBounds(newBounds);
        }
        updateMarkerBounds(markers);
    }
        , [markers]
    );

    useEffect(() => {
        if (viewport !== {}) {
            if (markerBounds && markerBounds[0][0] !== undefined) {
                var newViewport = new WebMercatorViewport(viewport).fitBounds(markerBounds, {
                    padding: 60,
                    maxZoom: 14,
                });
                setViewport(newViewport);
            }
        }
    }, [markerBounds]);

    const openModal = (place) => {
        setIsOpen(true);
        setSelectedRec(place);
        setSpotName(place.name);
        setSpotCaption(place.caption);
        setSpotIsPublic(place.isPublic)
    }
    const closeModal = () => {
        setIsOpen(false);
        setSelectedRec(selectedRec);
    }

    const openEditModal = () => {
        setIsEditModalOpen(true);
        renderEditModal();
    }
    
    const closeAllModals = () => {
        setIsEditModalOpen(false);
        setSpotName(null);
        setSpotCaption(null);
        setSpotIsPublic(null);
        closeModal();
    }

    const closeEditModal = () => {
        setIsEditModalOpen(false);
        setSpotName(null);
        setSpotCaption(null);
        setSpotIsPublic(null);
    }

    const getToggleIconState = () => {

        if (toggleDownState) {
            return (faChevronDown);
        } else {
            return (faChevronUp)
        }
    }

    const deleteRecommendation = async () => {
        try {
            const response = ApiV2.deleteRecommendation(selectedRec.id);

            response.then((val) => {
                setIsOpen(false);
                setFlag(false);
                props.notifyInfo(
                    "Successfully deleted " + selectedRec.name
                );
                closeModal();
            });
        } catch (e) {
            console.log("Error: ", JSON.stringify(e));
            props.notifyFailure(
                "Failed to delete recomendation."
            );
        }
    }

    // TODO: implement this backend call for edit recommendation. Use this function on the save button.
    const updateSpot = async () => {
        var updatedSpot = selectedRec;
        updatedSpot.name = spotName;
        updatedSpot.caption = spotCaption;
        updatedSpot.isPublic = spotIsPublic;

        try {
            const response = await ApiV2.updateSpot(
                updatedSpot
            );            
            closeAllModals();
            props.notifyInfo(
                "Successfully updated Recommendation"
            );
        } catch (error){
            console.log("unable to edit error:", JSON.stringify(error));
            props.notifyFailure(
                "Failed to edit Recommendation"
            );
        }
    }

    const getLocation = useCallback((location) => {
        setCurrentLocation(location.coords);
    }, []);

    const renderSpotMarkers = () => {
        if (Array.isArray(currentRecList.list)) {
            const markers = currentRecList.list.map(spot => {
                return (
                    <Marker latitude={spot.mapboxData.center[1]} longitude={spot.mapboxData.center[0]} offsetLeft={-12} offsetTop={-30}>
                        {/* <FontAwesomeIcon onClick={() => togglePopup(!showPopup)} className='text-primary fa-2x' icon={faMapMarkerAlt} /> */}
                        <FontAwesomeIcon className='text-primary fa-2x' icon={faMapMarkerAlt} />
                    </Marker>
                );
            });
            return markers;
        }
    }

    const getDistance = (place) => {
        if(currentLocation.longitude){
            var from = turf.point([currentLocation.longitude, currentLocation.latitude]);
            var to = turf.point([place.mapboxData.center[0], place.mapboxData.center[1]]);
            var options = {units: 'miles'};
    
            var distance = turf.distance(from, to, options);
            return distance.toFixed(1);
        }
        return
    }

    const renderRecommendations = () => {
        if (Array.isArray(currentRecList.list)) {
            const places = currentRecList.list.map(place => {
                return (
                    <Spot
                        place={place}
                        openModal={openModal}
                        getDistance={getDistance}
                    />
                );
            });
            return places;
        }
    }

    // TODO: FINISH IMPLEMENTATION OF EDIT REC
    const renderEditModal = () => {
        return (
            <Modal show={isEditModalOpen} onHide={() => closeEditModal()} centered>
                <Modal.Body>
                    <PhotoUpload 
                        className="mx-0"
                        onHide={closeEditModal}
                    notifyInfo={props.notifyInfo}
                    notifyFailure={props.notifyFailure}
                    idPrefix={selectedRec?.id}
                    photoType="SPOT"
                    />
                    <Form className="mt-2">
                        <Form.Group as={Row}>
                            <Col md={8}>
                                <Form.Control
                                    type="text"
                                    placeholder="Recommendation name"
                                    value={spotName}
                                    onChange={event => {
                                        setSpotName(event.target.value);
                                    }}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-1">
                            <Col md={8}>
                                <Form.Control
                                    as="textarea" rows="3"
                                    maxLength="280"
                                    placeholder="Caption (280 characters limit)"
                                    value={spotCaption}
                                    onChange={event => {
                                        setSpotCaption(event.target.value);
                                    }}
                                    onKeyPress={e => {
                                        if (e.key === "Enter") {
                                            this.onRegisterClicked();
                                        }
                                    }}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group className="mb-1">
                            <Form.Check
                                type="switch"
                                label="Public"
                                defaultChecked={spotIsPublic}
                                onChange={event => {
                                    setSpotIsPublic(event.target.value);
                                }}
                            />
                        </Form.Group>
                        <Button className="" variant="primary" size="" onClick={() => updateSpot()} block>
                            Save
                        </Button>

                        <Button onClick={() => closeEditModal()} className="blue" variant="light" size="" block>
                            Cancel
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        );
    }

    if (props.currentRecList == null || props.currentRecList.list == 0) {
        return (
            <Redirect
                to={{ pathname: "/profile", state: { from: props.location } }}
            />
        );
    } else {
        return (
            <>
            <Navbar expand="lg" bg="light" variant="light" sticky="top" className="top-nav nav-fill">
                <Nav >
                    <Nav.Link className="p-0">
                        <Button variant="link" onClick={() => props.history.goBack()}>
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </Button>
                    </Nav.Link>
                </Nav>
                <Navbar.Brand className="brand">{currentRecList.name}</Navbar.Brand>
            </Navbar>
            <Container className="child-container">
                <Modal show={isOpen}
                    onHide={() => closeModal()}
                    centered>

                    <Modal.Header>
                        <Modal.Title className="modal-title">{selectedRec?.name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Col>
                            <Button onClick={() => closeModal()}
                                className="blue"
                                variant="light"
                                block>
                                Share
                            </Button>
                            {
                                inProfile ? 
                                <Button onClick={() => openEditModal()}
                                    className="blue"
                                    variant="light"
                                    // size="lg"
                                    block>
                                    Edit
                                </Button> : <></>
                                }
                            {
                                inProfile ?
                                <Button onClick={async () => {
                                    await deleteRecommendation();
                                }}
                                    variant="danger"
                                    // size="lg"
                                    block>
                                    Delete
                                </Button> : <></>
                            }
                            <Button onClick={() => closeModal()}
                                className="blue"
                                variant="light"
                                block>
                                Cancel
                            </Button>
                        </Col>
                    </Modal.Body>
                </Modal>

                {renderEditModal()}

                <Accordion defaultActiveKey="0" className="mb-1">
                    <Card className="p-0 full-width">
                        <Card.Header className="p-0">
                            <Accordion.Collapse eventKey="0" className="full-width">
                                <Map
                                    ref={mapRef}
                                    {...viewport}
                                    width="100%"
                                    height="50vh"
                                    mapStyle={mapStyle}
                                    onViewportChange={viewport => setViewport(viewport)}
                                    mapboxApiAccessToken={MAPBOX_TOKEN}
                                    className='rounded'
                                >
                                    {renderSpotMarkers()}
                                    <GeolocateControl
                                        style={geolocateControlStyle}
                                        positionOptions={{ enableHighAccuracy: false }}
                                        trackUserLocation={true}
                                        onGeolocate={getLocation}
                                        onViewportChange={() => { console.log("Updated viewport") }}
                                        auto
                                    />
                                    <NavigationControl showCompass={false} style={navControlStyle} />
                                    <ScaleControl maxWidth={100} unit="imperial" style={scaleControlStyle} />
                                </Map>
                            </Accordion.Collapse>
                            <Container>
                                <Row className="justify-content-center">
                                    <Accordion.Toggle as={Button} variant="link" eventKey="0" onClick={() => setToggleDownState(!toggleDownState)}>
                                        <FontAwesomeIcon id="toggle-down" icon={getToggleIconState()} />

                                    </Accordion.Toggle>
                                </Row>
                            </Container>
                        </Card.Header>
                    </Card>
                </Accordion>
                <ListGroup className="full-width bottom-pad">
                    {renderRecommendations()}
                </ListGroup>
            </Container>
            </>
        );
    }
}

ListRecommendation.propTypes = {
    userRecs: PropTypes.array.isRequired,
    currentRecList: PropTypes.object.isRequired,
    setCurrentRecList: PropTypes.func.isRequired,
    // notifySuccess: PropTypes.func.isRequired,
    notifyInfo: PropTypes.func.isRequired,
    // notifyFailure: PropTypes.func.isRequired,
};

export default withRouter(ListRecommendation);


